<template>
  <Wrapper>
    <PlatformCode />
  </Wrapper>
</template>

<script setup>
import Wrapper from '@/components/Wrapper.vue'
import PlatformCode from '@/components/PlatformCode.vue'
</script>